// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

// Import Images
import darkLogo from "../../assets/images/dark-logo.svg";
import laptopImg from "../../assets/images/auth-laptop-image.png";


// Import Icons
import googleIcon from "../../assets/images/icons/google-icon.svg";
import microsoftIcon from "../../assets/images/icons/microsoft-icon.svg";
import eyeHideIcon from "../../assets/images/icons/eye-hide-icon.svg";
import eyeViewIcon from "../../assets/images/icons/eye-view-icon.svg";


function OtcTrade() {

    const [passwordsVisibility, setPasswordsVisibility] = useState({
        userPassword: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field) => {
        setPasswordsVisibility((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };


    return (
        <div className='login-page'>
            <section className="sec-auth">
                <div className="auth-banner-wrapper">
                    <span className="top-notch"></span>
                    <div className="auth-banner-card">
                        <a href="#" className="logo">
                            <img src={darkLogo} alt="logo" />
                        </a>
                        <div className="laptop-img">
                            <img src={laptopImg} alt="img" />
                        </div>
                    </div>
                </div>
                <div className="user-auth-wrapper">
                    <div className="form-wrapper">
                        <h3 className="h-font">Login</h3>
                        <ul className="social-auth">
                            <li><a href="#" className="btn-style icon transparent"><img src={googleIcon} alt="icon" />Sign in with Google</a></li>
                            <li><a href="#" className="btn-style icon transparent"><img src={microsoftIcon} alt="icon" />Sign in with Microsoft</a></li>
                        </ul>
                        <div className="form auth-form">
                            <div className="form-group">
                                <label htmlFor="user-email">Email ID</label>
                                <input type="email" id="user-email" className="form-control" placeholder="Enter Email" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="user-password">Password</label>
                                <div className="key-input">
                                    <input
                                        type={passwordsVisibility.userPassword ? "text" : "password"}
                                        id="user-password"
                                        className="form-control"
                                        placeholder="Enter Password"
                                    />
                                    <img
                                        src={passwordsVisibility.userPassword ? eyeHideIcon : eyeViewIcon}
                                        className="icon"
                                        alt="toggle visibility"
                                        onClick={() => togglePasswordVisibility('userPassword')}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                                <div className="more-link">
                                    <Link to="/forgot" className="f-12 w-600">Forgot password?</Link>
                                </div>
                            </div>
                            <div className="form-group submit">
                                <Link to="/" className="btn-style full dark">Log In</Link>
                                <div className="no-account">
                                    <p className="f-12 w-600">Don’t have an account? <Link to="/signup" className="f-12 w-600">Sign Up</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default OtcTrade
